import useCapabilities from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";

/**
 * Hook for checking university staff permissions and access controls.
 * University staff users are restricted to university routes only and cannot access system pages outside of their university.
 */
export const useUniversityStaffPermissions = () => {
  const { hasRole } = useCapabilities();
  const isUniversityStaff = hasRole(ROLE.UNIVERSITY_STAFF);

  return {
    /** True if the current user is university staff */
    isUniversityStaff,

    /** True if the user can access people pages (non-university staff) */
    canAccessPeoplePages: !isUniversityStaff,

    /** True if the user can access non-university routes (non-university staff) */
    canAccessNonUniversityRoutes: !isUniversityStaff,

    /** True if person profile actions should be shown (non-university staff) */
    shouldShowPersonProfileActions: !isUniversityStaff,

    /** True if facility profile actions should be shown (non-university staff) */
    shouldShowFacilityProfileActions: !isUniversityStaff
  };
};
